<eds-panel theme="dark" [edsSpacing]="'none'">
  <div edsGrid>
    <!-- breadcrumbs  area -->
    <eds-breadcrumbs [items]="breadcrumbItems" theme="dark"> </eds-breadcrumbs>
  </div>
</eds-panel>
<ft-us-capital-gains-filters
  [filters]="filters"
  [hasNoShareClass]="hasNoShareClass"
  (selectedFilterType)="filterListing($event)"
  [recordsCount]="recordsCount"
  [isLoaded]="isPopulated"
></ft-us-capital-gains-filters>
<ft-us-capital-gains-listing
  [gridListing]="gridListing"
  [gridListingTotalPages]="gridListingTotalPages"
  [recordsCount]="recordsCount"
  [isFilterProcessing]="isFilterProcessing"
  (selectedPage)="onPageChanged($event)"
  (selectedPageSize)="onDropdownChange($event)"
></ft-us-capital-gains-listing>
